import React, { FunctionComponent } from "react"
import { ApolloProvider } from "@apollo/client"
import { client } from "./client"

export const wrapRootElement: FunctionComponent<{
  element: React.ReactNode
}> = ({ element }) => <ApolloProvider client={client}>{element}</ApolloProvider>
